import { LDProvider } from "launchdarkly-react-client-sdk";
import { PrimeReactProvider } from "primereact/api";
import { createRoot } from "react-dom/client";
import {
  DDErrorBoundary,
  initDatadog,
  initDatadogLogs,
  getDatadogVersion,
} from "sj-ui-toolkit/src/integrations";
import { ThemeProvider } from "sj-ui-toolkit/src/theme/ThemeProvider";
import App from "./App";

// Import atlas base styles
import "sj-ui-toolkit/src/atlas/styles/index.scss";

// Import tailwind via styles.css
import "./styles.css";

// Import theme utilities
import "sj-ui-toolkit/src/atlas/utils/themeUtilities.css";

const version = getDatadogVersion();

// Log app info on startup
console.log(`🚀 login${version ? `: v${version}` : " (no version)"}`);

// ⚠️ WARNING: These credentials are UNIQUE to login-frontend!
// DO NOT copy these to other apps. Each app MUST have its own RUM application.
// To add RUM to a new app: Create new RUM app in Datadog UI, get unique credentials.
// See: .github/instructions/frontend-rum-standards.instructions.md

// Initialize RUM
initDatadog({
  applicationId: "286deffa-7a28-4a26-b0dc-4734463e942b", // ⚠️ UNIQUE to login
  clientToken: "pubf49e11b09c54749c424050ce612de7fd", // ⚠️ UNIQUE to login
  service: "login-frontend",
  version, // Dev: Git SHA, Prod: Semantic version
});

// Initialize Browser Logs (uses same client token as RUM)
initDatadogLogs({
  clientToken: "pubf49e11b09c54749c424050ce612de7fd", // ⚠️ Same as RUM
  service: "login-frontend",
  version,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ["error"],
});

createRoot(document.getElementById("root")!).render(
  <PrimeReactProvider>
    <ThemeProvider loaderOptions={{ loaderOn: true, hideLoaderText: true }}>
      <LDProvider
        clientSideID={import.meta.env.VITE_APP_LAUNCHDARKLY_ID || "638e4dc08684e4120d9a92ef"}
      >
        <DDErrorBoundary>
          <App />
        </DDErrorBoundary>
      </LDProvider>
    </ThemeProvider>
  </PrimeReactProvider>
);
